export default __webpack_public_path__ + "static/media/medical.926eb225.webp";